module.exports = __webpack_public_path__ + "5dacd004927da04b74e271b176c3dee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/pattern-bg/pattern-bg-3.png
// module id = 407
// module chunks = 0